/* eslint no-console:0 */
// This file is automatically compiled by Webpack, along with any other files
// present in this directory. You're encouraged to place your actual application logic in
// a relevant structure within app/javascript and only use these pack files to reference
// that code so it'll be compiled.
//
// To reference this file, add <%= javascript_pack_tag 'application' %> to the appropriate
// layout file, like app/views/layouts/application.html.erb

// Uncomment to copy all static images under ../images to the output folder and reference
// them with the image_pack_tag helper in views (e.g <%= image_pack_tag 'rails.png' %>)
// or the `imagePath` JavaScript helper below.
//
// const images = require.context('../images', true)
// const imagePath = (name) => images(name, true)

import React from 'react';
import ReactDOM from 'react-dom';

// Top level css requires must be here so that bundler knows
// how to emmit css to the 'application' pack that is called
// in the layout view.
import 'works/assets/css/App.less';
import 'works/assets/css/fontshop.less';
import { App } from 'works/app';
import { initFullStory } from 'works/legacy/lib/fullstory';

initFullStory();

document.addEventListener('DOMContentLoaded', () => {
  ReactDOM.render(<App />, document.getElementById('works-container'));
});
